import React from "react";
import "./UserPopup.css";
import catPhoto from "../../images/cat-photo.png";

const UserPopup = ({ user, groupName, role, onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        <div className="popup-header">
          <img
            src={catPhoto}
            alt={`${user.name} ${user.surname}`}
            className="popup-user-image"
          />
          <h3 className="popup-user-name">
            {`${user.surname} ${user.name} ${user.patronymic || ""}`}
          </h3>
        </div>
        <div className="popup-info">
          <p>
            <strong>Отдел:</strong> {groupName}
          </p>
          <p>
            <strong>Должность:</strong> {role}
          </p>
          <p>
            <strong>Дата рождения:</strong> {user.birth_date || "Не указана"}
          </p>
          <p>
            <strong>Телефон:</strong> {user.phone_number || "Не указан"}
          </p>
          <p>
            <strong>Email:</strong> {user.email || "Не указан"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserPopup;
